<section>
  <button type="button" class="btn btn-back d-flex align-items-center py-5"
    [routerLink]="['/sales-activities/sales-list']" routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png" alt=""> <span class="mx-4">Back</span>
  </button>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">

      <div class="my-4">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-5">
            <div class="card h-100" style="border: 1px solid var(--color-green-light-active); background: #b6d1c136">
              <div class="card-body card-body-custom">

                <div class="row py-1 py-lg-3">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-box">Sales Name</h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <h5 class="title-box-bold"> {{ ItemSalesListDetail.sales_name }} </h5>
                  </div>
                </div>

                <div class="row py-1 py-lg-3">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-box">Sales Type</h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 text-end">
                    <h5 class="title-box-bold"> {{ ItemSalesListDetail.sales_type }} </h5>
                  </div>
                </div>

                <div class="row py-1 py-lg-3">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-box">No Handphone</h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <h5 class="title-box-bold"> {{ ItemSalesListDetail.phone_number }} </h5>
                  </div>
                </div>

                <div class="row py-1 py-lg-3">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-box">Total Activity</h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <h5 class="title-box-bold"> {{ ItemSalesListDetail.total_activity }} </h5>
                  </div>
                </div>

                <div class="row py-1 py-lg-3">
                  <div class="col-6 col-md-6 col-lg-6">
                    <h5 class="title-box">Total Revenue</h5>
                  </div>
                  <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                    <h5 class="title-box-bold"> {{ ItemSalesListDetail.total_revenue | rupiah }}</h5>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 col-lg-7 my-4 my-lg-0">
            <div class="card h-100">
              <div class="card-body card-body-custom">
                <h5 class="card-title card-title-custom">
                  <img src="assets/icons/revenue-lease.png"> Activity State
                </h5>

                <div class="container-box-information-activity" *ngFor="let activity of ItemSalesActivityState">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-box">{{ activity.title }}</h5>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <h5 class="title-box-bold">{{ activity.num_activity }}</h5>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="heading-1">Activity list</h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control" placeholder="Search Sales Name" [(ngModel)]="searchTerm"
              (keyup)="onSearchSalesType($event)" [value]="searchTerm">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center sortable-header" (click)="onSort('property_name')">
                <span>Property Name</span>
                <i [class]="getSortIcon('property_name')" class="sort-icon"></i>
              </th>
              <th class="text-center">
                <span>Property Type/Floor</span>
              </th>
              <th class="text-center">
                <span>Source of Booking</span>
              </th>
              <th class="text-center sortable-header" (click)="onSort('cust_name')">
                <span>Customer Name</span>
                <i [class]="getSortIcon('cust_name')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('trans_date')">
                <span>Date</span>
                <i [class]="getSortIcon('trans_date')" class="sort-icon"></i>
              </th>
              <th class="text-center">
                <span>State</span>
              </th>
              <th class="text-center">
                <span>Revenue</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- Loading State -->
            <ng-container *ngIf="isLoading">
              <tr>
                <td colspan="7" class="text-center">
                  <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            </ng-container>

            <!-- Data Available -->
            <ng-container *ngIf="!isLoading && ItemSalesActivityList.length > 0">
              <tr *ngFor="let item of ItemSalesActivityList">
                <td class="text-start">
                  {{ item.property_name }}
                </td>
                <td class="text-center">{{ item.property_type }}</td>
                <td class="text-center">{{ item.source_of_booking }}</td>
                <td class="text-center">{{ item.cust_name }}</td>
                <td class="text-center">{{ item.trans_date | dateformat }}</td>
                <td class="text-center">
                  <span [ngSwitch]="item.state">
                    <span *ngSwitchCase="'Hand Over'" class="badge badge-handover">{{ item.state }}</span>
                    <span *ngSwitchCase="'Won'" class="badge badge-won">{{ item.state }}</span>
                    <span *ngSwitchCase="'Inquiry'" class="badge badge-inquiry">{{ item.state }}</span>
                    <span *ngSwitchCase="'Lost'" class="badge badge-lost">{{ item.state }}</span>
                    <span *ngSwitchDefault>{{ item.state }}</span>
                  </span>
                </td>
                <td class="text-end">{{ item.revenue | rupiah }}</td>
              </tr>
            </ng-container>

            <!-- No Data Available -->
            <ng-container *ngIf="!isLoading && ItemSalesActivityList.length === 0">
              <tr>
                <td colspan="7" class="text-center">No sales activities found</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button" tabindex="0"
          *ngFor="let item of ItemSalesActivityList; let i = index">
          <div class="card-header card-sm-header">
            <h5>{{ item.property_name }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title">Property Name</div>
                <div class="card-sm-title">Property Type/Floor</div>
                <div class="card-sm-title">Source of Booking</div>
                <div class="card-sm-title">Customer Name</div>
                <div class="card-sm-title">Sales Percentage</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title">{{ item.property_name }}</div>
                <div class="card-sm-title">{{ item.source_of_booking }}</div>
                <div class="card-sm-title">{{ item.cust_name }}</div>
                <div class="card-sm-title">{{ item.trans_date | dateformat }}</div>
                <div class="card-sm-title">
                  <span [ngSwitch]="item.state">
                    <span *ngSwitchCase="'Hand Over'" class="badge badge-handover">{{ item.state }}</span>
                    <span *ngSwitchCase="'Won'" class="badge badge-won">{{ item.state }}</span>
                    <span *ngSwitchCase="'Inquiry'" class="badge badge-inquiries">{{ item.state }}</span>
                    <span *ngSwitchCase="'Lost'" class="badge badge-loss">{{ item.state }}</span>
                    <span *ngSwitchDefault>{{ item.state }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start mb-3">
          <div class="pagination-info">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </div>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>


  </div>

</section>
